import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export function PageHeader({ title, showBack = false, rightElement = null }) {
    const navigate = useNavigate();

    return (
        <header className="page-header" data-testid="page-header">
            <div className="flex items-center justify-between max-w-lg mx-auto">
                <div className="flex items-center gap-2">
                    {showBack && (
                        <button
                            onClick={() => navigate(-1)}
                            className="btn-ghost p-2 -ml-2"
                            aria-label="Go back"
                            data-testid="back-button"
                        >
                            <ChevronLeft className="w-6 h-6" />
                        </button>
                    )}
                    <h1 className="text-xl font-bold text-primary">{title}</h1>
                </div>
                {rightElement && <div>{rightElement}</div>}
            </div>
        </header>
    );
}

export default PageHeader;
